import {  GET_YEARLY_BREED_SALES_CONTRACTS_INFO, FETCH_BREED_DASHBOARD_AVAILABLE_BREEDS, GET_BREED_COUNT_AVAILABLE_BREEDS_WITH_MINIMUM_QUANTITY } from '../actions';
    
    const initialState = {
      contractsYearlyBreedSalesData:null, 
    }; 
    function BreedSalesDashBoardReducer(state = initialState, action) {
      let contractsYearlyBreedSalesData, dashBoardAvailableBreeds, dashBoardBreedsCount;     
      switch (action.type) {    
        case `${GET_YEARLY_BREED_SALES_CONTRACTS_INFO}_FULFILLED`:
          contractsYearlyBreedSalesData = action.payload.data;
          return { ...state, loading: false, contractsYearlyBreedSalesData };

        case `${FETCH_BREED_DASHBOARD_AVAILABLE_BREEDS}_FULFILLED`:
          dashBoardAvailableBreeds = action.payload.data;
          return { ...state, loading: false, dashBoardAvailableBreeds };
      
        case `${GET_BREED_COUNT_AVAILABLE_BREEDS_WITH_MINIMUM_QUANTITY}_FULFILLED`:
          dashBoardBreedsCount = action.payload.data;
          return { ...state, loading: false, dashBoardBreedsCount };

        case `${GET_YEARLY_BREED_SALES_CONTRACTS_INFO}_REJECTED`:
          return { ...state, loading: false,  contractsYearlyBreedSalesDataError: `${action.payload.message}`, state: initialState };  

        case `${FETCH_BREED_DASHBOARD_AVAILABLE_BREEDS}_REJECTED`:
          return { ...state, loading: false, dashBoardAvailableBreedsError: action.payload.response.data, state: initialState, };

        case `${GET_BREED_COUNT_AVAILABLE_BREEDS_WITH_MINIMUM_QUANTITY}_REJECTED`:
          return {...state, loading: false, dashBoardBreedsCountError: action.payload.response.data, state: initialState,};

        default:
          return state;
      }
    }  
    export default BreedSalesDashBoardReducer;
    
    